import styled from 'styled-components';

export const FollowingWrapper = styled.section`
  padding: 24px 16px;
`;
